<template>
    <div>
        <form method="get"
              class="searchForm"
              :class="openClass"
              @submit.prevent="handleRedirect">
            <div class="flex searchArea">
                <input
                    class="searchInput"
                    type="search"
                    :value="searchQuery"
                    @input="updateSearchQuery"
                    :placeholder="lang.placeholder"
                    ref="searchInput"
                />

                <div class="searchDropdown">
                    <button class="dropdownToggle" type="button">
                        <span class="toggleActive">{{ typeOptions[searchType] }}</span>
                        <span class="fa fa-caret-down"></span>
                    </button>
                    <ul class="dropdownMenu">
                        <li v-for="(label, type) in typeOptions" :key="type">
                            <a href="javascript:"
                               @click="updateSearchType(type)"
                            >{{ label }}</a>
                        </li>
                    </ul>
                </div>
                <button class="searchButton" aria-label="zoeken" type="submit" @click.prevent="handleRedirect()">
                    <svg v-if="!isLoading" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="width: 20px; vertical-align: middle;">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <span v-else>
                        <img src="/images/AjaxLoader.gif" class="searchMobileLoading mt5" alt="loading" />
                    </span>
                </button>
            </div>

            <div v-if="isOpen" class="autoCompleteSearch">
                <div v-show="hasResults" class="search-results">
                    <header-search-category
                        v-if="results.products && results.products.total_count > 0"
                        title="Producten"
                        :items="results.products.items"
                        :amount="results.products.total_count"
                        :action="getActionUrlForCategory('products')"
                    >
                        <template #link="{ item }">
                            <a :href="`/${item.slug}`" class="searchItem">
                                <div class="product-image">
                                    <img :src="item.thumbnail" :alt="item.title">
                                </div>
                                <div class="product-info">
                                    <div class="boldFont">{{ item.title }} ({{ item.type }})</div>
                                    <div>{{ item.authors }}</div>
                                </div>
                            </a>
                        </template>
                    </header-search-category>

                    <header-search-category
                        v-if="results.articles && results.articles.total_count > 0"
                        title="Artikelen"
                        :items="results.articles.items"
                        :amount="results.articles.total_count"
                        :action="getActionUrlForCategory('articles')"
                    >
                        <template #link="{ item }">
                            <a :href="item.url" class="searchItem">
                                <div>{{ item.title }}</div>
                                <div class="article-label">{{ item.type }}</div>
                            </a>
                        </template>
                    </header-search-category>

                    <header-search-category
                        v-if="results.faq && results.faq.total_count > 0"
                        title="FAQ"
                        :items="results.faq.items"
                        :amount="results.faq.total_count"
                        :action="getActionUrlForCategory('faq')"
                    >
                        <template #link="{ item }">
                            <a :href="`/${item.slug}`" class="searchItem">
                                <div>{{ item.question }}</div>
                            </a>
                        </template>
                    </header-search-category>

                    <header-search-category
                        v-if="results.pages && results.pages.total_count > 0"
                        title="Pagina's"
                        :items="results.pages.items"
                        :amount="results.pages.total_count"
                        :action="getActionUrlForCategory('pages')"
                    >
                        <template #link="{ item }">
                            <a :href="item.url" class="searchItem">
                                <div>{{ item.title }}</div>
                            </a>
                        </template>
                    </header-search-category>
                </div>
                <div v-show="!hasResults && this.searchQuery.length >= 3 && !this.isLoading">
                    <div class="searchItem">Geen resultaten gevonden</div>
                </div>

                <!--               <li v-for="result in results">-->
                <!--                   <a :href="result.url" >-->
                <!--                       <div v-if="result.image != ''" class="searchImage">-->
                <!--                           <img v-bind:src="result.image" v-bind:alt="result.title"  />-->
                <!--                       </div>-->
                <!--                       <div class="searchRight">-->
                <!--                           <span class="searchTitle" v-text="result.title"> </span>-->
                <!--                           <span v-if="result.originalPrice" v-html="result.originalPrice" class="searchOldPrice"></span>-->
                <!--                           <span v-if="result.price" v-html="result.price" class="searchPrice"></span>-->
                <!--                       </div>-->
                <!--                   </a>-->
                <!--               </li>-->
            </div>
        </form>
    </div>
</template>

<script>
import HeaderSearchCategory from "./HeaderSearchCategory";

export default {
    components: {HeaderSearchCategory},
    props: {
        lang: {
            required: false,
            type: Object,
            default() {
                return {
                    placeholder: 'Type to search..',
                }
            }
        },
    },
    data: function () {
        return {
            isOpen: true,
            isFilled: false,
            currentLang: {},
            currentType: 'null',
            typeOptions: {
                null: 'Bekijk alles',
                boeken: 'Boeken',
                ebook: 'E-books',
                audio: 'Luisterboeken',
                spellen: 'Spellen',
                waaiers: 'Waaiers',
                pages: 'Pagina\'s',
            },
        }
    },
    methods: {
        updateSearchQuery(value) {
            this.isFilled = false;

            if (typeof value === "object") {
                value = value.target.value;
                if (value.length > 0) {
                    this.isFilled = true;
                }
            }

            this.$store.dispatch('search/updateSearchQuery', value)
        },
        updateSearchType(type) {
            this.$store.dispatch('search/updateSearchType', type)
        },
        handleRedirect() {
            if (this.isOpen && this.isFilled) {
                window.location.href = this.action;
            } else {
                this.isOpen = !this.isOpen;
            }
        },
        getActionUrlForCategory(category) {
            let url = this.action;
            url += url.includes('?') ? `&${category}` : `?${category}`;
            return url;
        }
    },
    computed: {
        action() {
            return this.$store.getters["search/searchPageUrl"];
        },
        isLoading(){
            return this.$store.state.search.isLoading;
        },
        searchQuery() {
            return this.$store.state.search.searchQuery;
        },
        searchType() {
            return this.$store.state.search.searchType;
        },
        results() {
            return this.$store.state.search.results || {};
        },
        openClass() {
            return this.isOpen ? 'open' : '';
        },
        hasResults() {
            return Object.keys(this.results).length > 0 && (
                this.results?.articles.total_count > 0 || this.results?.products.total_count > 0 || this.results?.faq.total_count > 0 || this.results?.pages.total_count > 0
            );
        }
    },
    mounted() {
        this.currentLang = this.lang;
        const searchContainer = document.querySelector('.searchArea');
        const resultContainer = document.querySelector('.search-results');
        const headerElement = document.querySelector('.header');
        const searchDropdownElement = document.querySelector('.searchDropdown');

        window.addEventListener('click', (event) => {
            let path = event.path || (event.composedPath && event.composedPath());
            if (
                path &&
                (
                    path.includes(searchContainer) ||
                    path.includes(resultContainer) ||
                    document.activeElement === searchContainer.querySelector('input')
                )
            ) {
                headerElement.classList.add('open');
                setTimeout(() => searchDropdownElement.classList.add("show"), 300);
            } else {
                headerElement.classList.remove("open");
                searchDropdownElement.classList.remove("show");
            }
        }, {passive: true});
    },
    created() {
    }

}
</script>
<style>
.autoCompleteSearch {
    display: none;
}

.header.open .autoCompleteSearch {
    margin-top: .25rem;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, .5);
    border-radius: .25rem;
    background: white;
    display: flex;
    flex-direction: column;
    width: calc(100% - 200px);
}

@media screen and (max-width: 930px) {
    .header.open .autoCompleteSearch {
        width: 95%;
    }
}

.autoCompleteSearch > li > a {
    display: flex;
    align-items: center;
}

.result-category:last-of-type {
    margin-bottom: .5rem;
}

.searchItem {
    padding: 10px 15px;
    display: flex;
    column-gap: 10px;
    text-decoration: none;
    align-items: center;
}

.searchItem:hover {
    background: rgb(240, 240, 240);
}

/* PRODUCT */
.searchItem .product-image {
    align-items: center;
    display: flex;
    justify-content: center;
    max-height: 50px;
    width: 50px;
    position: relative;

    .stapelkorting{
        position: absolute;
        width: 35px;
        left: 0;
        top: 0;
    }
}

.searchItem .product-image img {
    max-height: 50px;
    max-width: 100%;
}

.searchItem .product-info {
    display: flex;
    row-gap: .5rem;
    flex-direction: column;
    justify-content: space-around;
}

/* ARTICLE */
.searchItem .article-label {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    padding: 5px 10px;
    background: rgb(249, 249, 249);
}

a.more-button {
    margin: 5px 15px;
    padding: 8px 15px;
    background: rgb(249, 249, 249);
    text-decoration: none;
    display: inline-block;
}

a.more-button:hover {
    background: rgb(236, 236, 236);
}
</style>
